const trackBeforeRedirect = (e, url, trackingCallback) => {
  const isNewTab = e.metaKey || e.ctrlKey;
  trackingCallback();
  if (!isNewTab) {
    e.preventDefault();
    setTimeout(() => {
      window.location.href = url;
    }, 300);
  }
};

export default trackBeforeRedirect;
